/**
 * Provides JS functionality for tracking alert display.
 */
class DoctorCardDisplay extends DrupalBehavior {

  onContent(context) {
    $('.doctor-card__play', context).each(function() {
      $(this).modalVideo({
        channel: $(this).attr('data-video-provider')
      });
    });
  }

}

DrupalBehavior.register('camc.components', 'doctorCardDisplay', DoctorCardDisplay);
